// extracted by mini-css-extract-plugin
export var sliderRange = "_rr-2";
export var sliderRoot = "_rr-0";
export var sliderThumb = "_rr-3";
export var sliderTrack = "_rr-1";